<template>
  <div class="quiz-question">
    <div class="question-header">
      <h4>{{ question.text }}</h4>
    </div>
    
    <div class="question-options">
      <div 
        v-for="option in question.options" 
        :key="option.id"
        class="option-item"
        :class="{ selected: isSelected(option.id) }"
        @click="selectOption(option.id)"
      >
        <div class="option-radio">
          <input 
            type="radio" 
            :name="`question-${question.id}`"
            :value="option.id"
            :checked="isSelected(option.id)"
            @change="selectOption(option.id)"
          />
          <span class="option-label">{{ getOptionLabel(option) }}</span>
        </div>
        <div class="option-text">{{ option.text }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  selectedOptions: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['select']);

const isSelected = (optionId) => {
  return props.selectedOptions.includes(optionId);
};

const getOptionLabel = (option, index) => {
  const labels = ['A', 'B', 'C', 'D', 'E'];
  const optionIndex = props.question.options.findIndex(o => o.id === option.id);
  return labels[optionIndex] || String(optionIndex + 1);
};

const selectOption = (optionId) => {
  // For single choice, replace the array with the new selection
  const newSelection = [optionId];
  emit('select', props.question.id, newSelection);
};
</script>

<style scoped>
.quiz-question {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin: 20px 0;
}

.question-header {
  margin-bottom: 20px;
}

.question-header h4 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.question-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-item {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.option-item:hover {
  border-color: #129f46;
  background: #f0f9f4;
}

.option-item.selected {
  border-color: #129f46;
  background: #e8f5e9;
}

.option-radio {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.option-radio input[type="radio"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.option-label {
  font-weight: bold;
  color: #129f46;
  min-width: 30px;
}

.option-text {
  color: #333;
  font-size: 15px;
}
</style>

